import API from '../libs/amplify.lib';

import { API_NAME } from '../constants';
import { parseResponse } from '../libs/response.lib';
import { generateQueryStringFromObject } from '../utils/query.util';
import { clientAuthContext } from '../libs/auth.context';

export const getClientAuthToken = async () => API.get(API_NAME, "/client/token")
  .then(parseResponse);

export const getUser = async (query) => API.get(API_NAME, `/user/me?${generateQueryStringFromObject(query)}`, {
  headers: {
      'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
    },
})
  .then(parseResponse);
 
export const getAllUsers = async (accountId) => API.get(API_NAME, `/user/list?accountId=${accountId}`, {
  headers: {
      'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
    },
}).then(parseResponse);

export const inviteUser = async ({ adminEmail, accountId, role, email, firstName, lastName }) =>
  API.post(API_NAME, `/user/invite-user`,
  {
    body: { adminEmail, accountId, role, email, firstName, lastName },
    headers: {
      'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
    },
  })
  .then(parseResponse);

export const updateRole = async ({ role, userId }) =>
  API.put(API_NAME, `/user/update-role`,
  {
    body: { role, userId },
    headers: {
      'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
    },
  })
  .then(parseResponse);

export const deleteUser = async ({ accountId, userId }) =>
  API.del(API_NAME, `/user/delete?userId=${userId}&accountId=${accountId}`, {
    headers: {
      'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
    },
  }).then(parseResponse);

export const updateUserSettings = async (payload, query = { operation: 'basicField' }) => API.put(API_NAME,
  `/user?${generateQueryStringFromObject(query)}`, { body: payload }, {
    headers: {
      'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
    },
  })
  .then(parseResponse);

/** *****               ACCOUNT             ******* */

export const getAccountSettings = async (query) => API.get(API_NAME, `/account?${generateQueryStringFromObject(query)}`, {
  headers: {
      'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
    },
})
  .then(parseResponse);

export const updateAccountSettings = async (payload) => API.put(API_NAME, '/account', { body: payload }, {
  headers: {
      'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
    },
})
  .then(parseResponse);

export const setCognitoId = async (payload) => API.post(API_NAME, '/user/register', { body: { operation: 'register', data: payload} })
  .then(parseResponse);

export const resetAccountSettings = async (payload) => API.put(API_NAME, '/account',
  { body: { ...payload, operation: 'resetAccountSettings' } })
  .then(parseResponse);